
/* ======= 会员 */
/** 未签到/未领取奖励 金币 */
export const UnSignCoinImg = 'https://m.hellobike.com/resource/gallery/59/Kc8uo3Vq_38x38.png';
/** 已签到 金币堆 */
export const SignedCoinImg = 'https://m.hellobike.com/resource/gallery/59/4lXIz1oj_b7055ac26849d084d4983a3e5206d4545d45a0bd.png';
/** 签到已领奖励 */
export const SignRewardReceivedImg = 'https://m.hellobike.com/resource/gallery/59/4lXIz1oj_b7055ac26849d084d4983a3e5206d4545d45a0bd.png';
/** 单单返已签到 */
export const RewardReceivedImg = 'https://m.hellobike.com/resource/gallery/59/f50a8iO1_328.png';
/** 会员 兑换>  按钮 */
export const ExchangeBtnImg = 'https://m.hellobike.com/resource/helloyun/08345/pD7xlkT1sj.png';
/** 右箭头 */
export const RightArrowIcon = 'https://m.hellobike.com/resource/helloyun/22871/Dz4o642Vyo.png';
/** 图标 */
export const ToggleIcon = 'https://m.hellobike.com/resource/helloyun/08345/cBQvnDJniF.png';
/** 锁定 */
export const LockIcon = 'https://m.hellobike.com/resource/gallery/59/yGbfakIW-O.png';
/** 2倍率 */
export const HotRadioDoubleIcon = 'https://m.hellobike.com/resource/gallery/59/RmowiLVe_x2.png';
/** 3倍率 */
export const HotRadioTripleIcon = 'https://m.hellobike.com/resource/gallery/59/lJLjQ5_R_x3.png';
/** 抽奖新样式背景 */
export const LotteryNewAppBgm = 'https://m.hellobike.com/resource/gallery/59/moBY60Rz_Slice%2011.png';
/** 引导蒙层文字图片 */
export const LightGuidTextImg = 'https://m.hellobike.com/resource/gallery/59/TTL-IdPE_Group%201707483354.png';

export const CloseIcon = 'https://m.hellobike.com/resource/gallery/59/mMnBPn4XiC.png';

export const FreeRightsVersionBg = 'https://m.hellobike.com/resource/gallery/43/rvSrakjp_8192.png';

/** header-menu 默认图片 */
export const HeaderMenuDefaultImg = 'https://m.hellobike.com/resource/helloyun/08345/x4P3I_Slice%206.png';
/** header-menu freeRightsVersion 图片 */
export const HeaderMenuFreeRightsImg = 'https://m.hellobike.com/resource/gallery/43/CguNTCiL_899912.png';

/** 新版会员 2tab 免单特权背景图片 左侧 */
export const TabMiandanLeft = 'https://assets.51downapp.cn/file-1755002060980-374562858.png';
/** 新版会员 2tab 免单双数背景图片 右侧 */
export const TabMiandanRight = 'https://assets.51downapp.cn/file-1755002060998-310316834.png';


/** 新版会员- 3tab 免单特权 选中状态图片 - 中间 */
export const TabSelectedMiddleFreeRightsImg = 'https://m.hellobike.com/3da07bf2_miandanMiddleTab.png';

/** 新版会员- 3tab 通用 选中状态图片 - 右边 */
export const ThreeTabCommonRightImg = 'https://m.hellobike.com/b0ccf6b5_new3TabCommonRight.png';
/** 新版会员- 3tab 通用 选中状态图片 - 左边 */
export const ThreeTabCommonLeftImg = 'https://m.hellobike.com/9c648fc5_new3TabCommonLeft.png';
/** 新版会员- 3tab 通用 选中状态图片 - 中间 */
export const ThreeTabCommonMidImg = 'https://m.hellobike.com/fdaef9db_new3TabNormalMid.png';


// 缺少新版会员2tab 通用图片 TODO以下图片要更新
/** 新版会员-普通版本 tab 选中状态图片 - 右侧 */
export const TabRightNormalImg = 'https://m.hellobike.com/05ccf372_yikaiRight.png';

// 新版会员2tab 助力车
export const TabEbikeLeftImg = 'https://m.hellobike.com/12ab3d1c_ebikeLeft.png';

// 一分骑版本推荐图片（新版会员）
export const oneCentRideRecommendImg = 'https://m.hellobike.com/d96fff81_78918923.png';
// 一分骑版本推荐图片（新版会员）
export const oneCentRideRecommendImgOldVersion = 'https://m.hellobike.com/6865822d_8892983.png';

// 骑行会员卡片图片
/** 单车推荐模块标题 */
export const BikeRideCardImg = 'https://m.hellobike.com/resource/gallery/61/FKaC4BpzKa.png';
/** 助力车推荐模块标题 */
export const EbikeRideCardImg = 'https://m.hellobike.com/resource/gallery/61/SOuQeSmqab.png';
/** 一分骑推荐模块标题 */
export const OneCentRideCardImg = 'https://m.hellobike.com/4be85425_892893832.png';
